/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {SpecialOrderDetailModel} from '../contracts/special-order-detail.model';

@Injectable({
    providedIn: 'root'
})
export class SpoDetailService {

    private specialOrderDetailUrl = `${environment.specialOrdersBaseUrl}/api/specialOrder/detail`;

    constructor(private http: HttpClient) {
    }

    getSpecialOrderDetail(spoNumber: string): Observable<SpecialOrderDetailModel> {
        return this.http.get<SpecialOrderDetailModel>(`${this.specialOrderDetailUrl}/${spoNumber}`);
    }
}
